/**
 * ActivityIcon — Cloudscape icon for a SFDC activity_type value, shared
 * across Impact (StageBreakdown timeline) and Motion (pipeline table +
 * activity popup). Renders nothing for types we intentionally don't
 * decorate (Other / null / unrecognized), so callers can drop it in
 * unconditionally.
 */

import { Icon, type IconProps } from '@amzn/awsui-components-react';
import './ActivityIcon.css';

// Exact-match over the 8 SFDC activity_type values seen in prod. Null
// for values we intentionally show no icon for (Other / null / empty
// / unrecognized).
function typeToIconName(type: string | null | undefined): IconProps.Name | null {
  switch (type) {
    case 'Call':
      return 'call';
    case 'Email':
    case 'InMail':
      return 'envelope';
    case 'Meeting':
      return 'calendar';
    case 'Executive Engagement':
      return 'group';
    case 'Live Chat':
      return 'contact';
    default:
      return null;
  }
}

export function ActivityIcon({ type }: { type: string | null | undefined }) {
  const name = typeToIconName(type);
  if (!name) return null;
  return (
    <span className="ivt-activity-type-icon" aria-hidden="true">
      <Icon name={name} variant="subtle" size="small" />
    </span>
  );
}
